import styled from 'styled-components'

export const BookmarksView = styled.div`
  > h1 {
    margin: 30px 0;
  }

  .link-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: 30px;

    &.right {
      justify-content: flex-end;
    }

    .back-link {
      display: block;
    }

    .compare-button {
      display: flex;
      justify-content: flex-start;
      line-height: 21px;

      @media ${ (props) => props.theme.breakpoints.devices.max.sm }, print {
        display: flex;
        justify-content: flex-start;
        width: auto;
        padding-top: 0;
      }
    }
  }

  // overwrite tab size (if just one item should rendered)
  .full-size {
    > ul > li {
      width: calc(100% - 4px);
    }
  }

  .bookmark-item {
    margin-bottom: 10px;
  }

  .bookmark-print {
    color: ${ (props) => props.theme.colors['standard-schwarz'] };
    margin-bottom: 0;
    align-self: baseline;
  }

  .bookmark-footer {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    margin-top: 30px;

    > * {
      width: auto;
    }

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      justify-content: flex-end;
      flex-wrap: nowrap;

      > *:not(:first-child) {
        margin-left: 30px;
      }
    }
  }

  // https://bugs.onedev.aok.de/secure/attachment/39208/39208_image-2020-07-31-15-57-22-947.png
  .bookmark-compare {
    order: -1;
    width: 100%;
    margin-bottom: 20px;
    margin-top: 21px;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      order: unset;
      width: auto;
      margin-bottom: 0;
    }
  }
`
